import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function AccountDisabled() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { reason?: string; email?: string } | null;

  const reason = state?.reason || 'Your account has been disabled. Please contact us to find out why.';

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-4">
            Account Disabled
          </h1>

          {/* Reason */}
          <p className="text-gray-600 text-center mb-8">
            {reason}
          </p>

          {/* Back to Login Button */}
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Back to Login</span>
          </button>

          {/* Additional Info */}
          {state?.email && (
            <p className="text-xs text-gray-500 text-center mt-4">
              Attempted login: {state.email}
            </p>
          )}
        </div>

        {/* Footer Note */}
        <p className="text-center text-gray-400 text-sm mt-6">
          This account has been temporarily disabled by an administrator.
        </p>
      </div>
    </div>
  );
}

